import { Button } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { Briefcase, ClipboardList, LogOut } from 'lucide-react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { fetchVendorMe, vendorLogout } from '../../api/vendor-auth.js';
import { useBrandingStore } from '../../stores/branding-store.js';

export function VendorLayout() {
  const navigate = useNavigate();
  const snapshot = useBrandingStore((s) => s.snapshot);
  const logoUrl = snapshot?.logoUrl ?? null;
  const orgName = snapshot?.orgName ?? null;

  const { data } = useQuery({
    queryKey: ['vendor', 'me'],
    queryFn: fetchVendorMe,
  });

  const signOut = async () => {
    await vendorLogout();
    navigate('/vendor', { replace: true });
  };

  return (
    <div className="flex min-h-dvh flex-col bg-bg">
      <header className="flex h-[60px] shrink-0 items-center justify-between bg-sidebar px-4 text-sidebar-fg">
        <div className="flex items-center gap-3">
          {logoUrl ? (
            <img src={logoUrl} alt="" className="h-8 w-auto max-w-[120px] object-contain" />
          ) : (
            <span className="text-sm font-semibold text-sidebar-fg">{orgName ?? 'SiteWise'}</span>
          )}
          {data?.company.name ? (
            <span className="rounded-full bg-white/10 px-2 py-0.5 text-xs text-sidebar-muted">
              {data.company.name}
            </span>
          ) : null}
        </div>
        <div className="flex items-center gap-3 text-sm text-sidebar-muted">
          <span>{data?.user.name}</span>
          <Button type="button" variant="ghost" size="sm" className="text-sidebar-fg hover:bg-white/10 hover:text-sidebar-fg" onClick={() => void signOut()}>
            <LogOut className="mr-1 h-4 w-4" />
            Sign out
          </Button>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-4 pb-20">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 flex h-16 border-t border-border bg-surface">
        <NavLink
          to="/vendor/work"
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-1 text-xs ${isActive ? 'font-semibold text-primary' : 'text-fg-muted'}`
          }
        >
          <Briefcase className="h-5 w-5" />
          Work
        </NavLink>
        <NavLink
          to="/vendor/logs"
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-1 text-xs ${isActive ? 'font-semibold text-primary' : 'text-fg-muted'}`
          }
        >
          <ClipboardList className="h-5 w-5" />
          Logs
        </NavLink>
      </nav>
    </div>
  );
}
